/* unplugin-vue-components disabled */import { render } from "./SpocCourse.vue?vue&type=template&id=2d57ad8c&scoped=true"
import script from "./SpocCourse.vue?vue&type=script&lang=js"
export * from "./SpocCourse.vue?vue&type=script&lang=js"

import "./SpocCourse.vue?vue&type=style&index=0&id=2d57ad8c&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户湖南中医药大学-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d57ad8c"]])

export default __exports__